// Teil „Eingang“ des Manifests (Paket UI-Eingang): E-Rechnungen von Lieferanten hochladen, lesen, prüfen, zuordnen
// und im Einkauf erfassen (SPEZIFIKATION §6, §6.8). Lesen verlangt zusätzlich „Einstandspreise sehen“ – das prüft der
// Server; die Seiten sagen es in einem Satz, wenn es fehlt. In Node ladbar: Seiten nur per lazy-Import.
import { STOCK_FEATURE } from '@shared/stock'
import type { WebModuleSpec } from '@web/module'
import { FileInput, FileUp } from 'lucide-react'

const INBOUND_READ = 'einvoice.inbound.read'
const INBOUND_IMPORT = 'einvoice.inbound.import'

export const INBOX_PATH = '/einvoice/inbox'

/**
 * Der Eingang führt in den Einkauf (Eingangsrechnung erfassen) und steht in dessen Gruppe: Ohne Bestandsführung des
 * Betriebs – dann ist der Einkauf ausgeblendet (docs/ohne-lager/SPEZIFIKATION.md) – verschwindet er mit.
 */
const WITH_PURCHASING = STOCK_FEATURE

/** Ansicht einer eingegangenen E-Rechnung (Ziel von Aufgaben und Benachrichtigungen des Servers) */
export const inboxHref = (inboundId: string): string => `${INBOX_PATH}/${encodeURIComponent(inboundId)}`

export const inbox: Omit<WebModuleSpec, 'id'> = {
  routes: [
    {
      path: INBOX_PATH,
      title: 'E-Rechnungen im Eingang',
      permission: INBOUND_READ,
      feature: WITH_PURCHASING,
      lazy: () => import('../pages/InboxPage'),
    },
    {
      path: `${INBOX_PATH}/:id`,
      title: 'Eingegangene E-Rechnung',
      permission: INBOUND_READ,
      feature: WITH_PURCHASING,
      lazy: () => import('../pages/InboxDetailPage'),
    },
  ],
  nav: [
    {
      section: 'purchasing',
      label: 'E-Rechnungen (Eingang)',
      icon: FileInput,
      to: INBOX_PATH,
      permission: INBOUND_READ,
      feature: WITH_PURCHASING,
      order: 28,
    },
  ],
  commands: [
    {
      id: 'einvoice.inbox',
      label: 'E-Rechnungen im Eingang anzeigen',
      keywords: ['XRechnung vom Lieferanten', 'ZUGFeRD', 'Eingangsrechnung', 'Rechnungseingang', 'E-Rechnung prüfen'],
      icon: FileInput,
      to: INBOX_PATH,
      permission: INBOUND_READ,
      feature: WITH_PURCHASING,
    },
    {
      id: 'einvoice.inbox.upload',
      label: 'E-Rechnung hochladen',
      keywords: ['XRechnung einlesen', 'ZUGFeRD hochladen', 'Rechnung vom Lieferanten', 'XML', 'PDF'],
      icon: FileUp,
      to: `${INBOX_PATH}?upload=1`,
      permission: INBOUND_IMPORT,
      feature: WITH_PURCHASING,
    },
  ],
  entityLinks: {
    // Aufgaben („Berichtigung anfordern“, „nicht lesbar“ …) und Benachrichtigungen hängen am Eingang
    einvoice_inbound: (id) => inboxHref(id),
  },
}
